module.exports = __webpack_public_path__ + "static/media/lizhijiaojiebiao1.acfa1da8.png";